import React, { Component } from "react";
import { connect } from "react-redux";
import { Spin } from "antd";

import {
  deleteReglement,
  loadReglements,
  updateReglements,
} from "../../store/actions/reglementAction";
import { loadLocataires } from "../../store/actions/locataireAction";
import { loadLocations } from "../../store/actions/locationAction";
import { loadComptes } from "../../store/actions/compteAction";
import { loadEcritures, saveEcriture } from "../../store/actions/ecritureAction";

import FormSuppressionReglement from "../../components/FormSuppressionReglement";

class SuppressionReglement extends Component {
  componentDidMount() {
    Promise.all([
      !this.props.comptes && this.props.loadComptes(),
      !this.props.locataires && this.props.loadLocataires(),
      !this.props.locations && this.props.loadLocations(),
      !this.props.reglements && this.props.loadReglements(),
      !this.props.ecritures && this.props.loadEcritures(),
    ]);
  }

  render() {
    const {
      annulation,
      idLocataire,
      comptes,
      locataires,
      locations,
      reglements,
      ecritures,
      utilisateur,
    } = this.props;

    return (
      <Spin
        size="large"
        tip="Chargement en cours..."
        spinning={!comptes || !locataires || !locations || !reglements || !ecritures}
      >
        <FormSuppressionReglement
          annulation={annulation}
          idLocataire={idLocataire}
          utilisateur={utilisateur}
          locataires={locataires}
          locations={locations}
          comptes={comptes}
          reglements={reglements}
          ecritures={ecritures}
          saveEcriture={this.props.saveEcriture}
          deleteReglement={this.props.deleteReglement}
          updateReglements={this.props.updateReglements}
        />
      </Spin>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadComptes: () => dispatch(loadComptes()),
    loadLocataires: () => dispatch(loadLocataires()),
    loadLocations: () => dispatch(loadLocations()),
    loadReglements: () => dispatch(loadReglements()),
    loadEcritures: () => dispatch(loadEcritures()),
    deleteReglement: (id) => dispatch(deleteReglement(id)),
    saveEcriture: (ecriture) => dispatch(saveEcriture(ecriture)),
    updateReglements: (jsonData) => dispatch(updateReglements(jsonData)),
  };
};

// mapper le state aux props du component
const mapStateToProps = (state) => {
  return {
    utilisateur: state.utilisateur.data,
    journals: state.journals.data,
    comptes: state.comptes.data,
    locataires: state.locataires.data,
    locations: state.locations.data,
    reglements: state.reglements.data,
    ecritures: state.ecritures.data,
    typesPaiements: state.typesPaiements.data,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SuppressionReglement);
